
// import React, { useState, useEffect } from 'react';
// import {
//   Box, Modal, Typography, Card, CardContent, Button, Table,
//   TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
//   IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
//   TextField, MenuItem, Grid, Tooltip, Badge, Avatar, Chip,
//   Select, FormControl, InputLabel, LinearProgress, Alert, Snackbar,
//   CircularProgress, Divider, Tabs, Tab, Pagination
// } from '@mui/material';
// import {
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Person as PersonIcon,
//   EventNote as EventNoteIcon,
//   Add as AddIcon,
//   Work as WorkIcon,
//   DateRange as DateRangeIcon,
//   Description as DescriptionIcon,
//   Timeline as TimelineIcon,
//   SupervisorAccount as SupervisorIcon,
//   Visibility as VisibilityIcon,
//   FilterList,
//   Search,
//   Sort,
//   ArrowDownward,
//   ArrowUpward,
//   CalendarMonth,
//   Comment,
//   PendingActions,
// } from '@mui/icons-material';
// import { styled, alpha } from '@mui/material/styles';
// import { 
//   BarChart, 
//   Bar, 
//   XAxis, 
//   YAxis, 
//   CartesianGrid, 
//   Tooltip as ChartTooltip, 
//   Legend, 
//   ResponsiveContainer 
// } from 'recharts';
// import axios from 'axios';
// import { localAxiosGet, localAxiosPut, localAxiosToken } from '../../Axios/axios';
// import TokenExpirePopup from '../../components/TokenExpirePopup';
// import { useNavigate } from 'react-router-dom';

// const StyledCard = styled(Card)(({ theme, type }) => ({
//   height: '100%',
//   backgroundColor: type === 'requests' ? '#E3F2FD' : '#FFF3E0',
//   boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
//   transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//   '&:hover': {
//     transform: 'translateY(-8px)',
//     boxShadow: '0 12px 20px rgba(0,0,0,0.15)',
//   },
//   cursor: 'pointer',
//   borderRadius: '16px',
// }));



// const EmployeeLeaves = () => {

//   const [openApplyLeave, setOpenApplyLeave] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//   const [leaveFormData, setLeaveFormData] = useState({
//     startDate: '',
//     endDate: '',
//     leaveType: '',
//     reason: '',
//     manager: '',
//   });

//   const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
//   const navigate = useNavigate();

//   const [isMyLeavesPopupOpen, setIsMyLeavesPopupOpen] = useState(false);
//   const [myLeaves, setMyLeaves] = useState([]);
//   const [loadingMyLeaves, setLoadingMyLeaves] = useState(false);
//   const [myLeavesError, setMyLeavesError] = useState('');
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//   const [sortBy, setSortBy] = useState('start_date');
//   const [sortOrder, setSortOrder] = useState('asc');
//   const [openEmployeeDetails, setOpenEmployeeDetails] = useState(false);
//   const [employeeDetailsData, setEmployeeDetailsData] = useState(null);
//   const [approvalComment, setApprovalComment] = useState('');
//   const [rejectionReason, setRejectionReason] = useState('');
//   const [actionTab, setActionTab] = useState(0); 


//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);


//   const [statusFilter, setStatusFilter] = useState('ALL');

//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
//   const [leaveTypesError, setLeaveTypesError] = useState('');

//   const [employeeLeaveBalance, setEmployeeLeaveBalance] = useState([]);
//   const [loadingLeaveBalance, setLoadingLeaveBalance] = useState(false);
//   const [leaveBalanceError, setLeaveBalanceError] = useState('');

//   const token = localStorage.getItem('accessToken');
//   const organizationId = localStorage.getItem('organizationId');
//   const reportingmanagerId = localStorage.getItem('reportingmanagerId');

//   const handleCloseTokenExpirePopup = () => {
//     setOpenTokenExpirePopup(false);
//     navigate('/'); 
//   };


//   const fetchLeaveRequests = async (page = 1, status = 'ALL') => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('accessToken');
//       const userId = localStorage.getItem('userId');

//       if (!token) {
//         throw new Error('Authentication token not found. Please login again.');
//       }
//       if (!userId) {
//         throw new Error('User ID not found. Please login again.');
//       }


//       let url = `/organization/getLeaveRequestsByManager/${userId}?page=${page}&limit=${pageSize}`;
//       if (status !== 'ALL') {
//         url += `&status=${status}`;
//       }

//       const response = await axios(localAxiosGet(url, token));

//       if (response.data.statusCode === 401) {
//         throw new Error('Your session has expired. Please login again.');
//       }

//       if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {

//         const paginationData = response.data.message;
//         setCurrentPage(paginationData.page);
//         setTotalPages(paginationData.totalPages);
//         setTotalRecords(paginationData.totalRecords);

//         const transformedData = await Promise.all(paginationData.data.map(async (request) => {

//           let statistics = {};

//           try {

//             const balanceResponse = await axios(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${request.user_id}`, token));
//             const balanceData = balanceResponse.data;

//             if (balanceData.statusCode === 200 && balanceData.status === "SUCCESS" && 
//                 balanceData.message && Array.isArray(balanceData.message.leaveTypesWithBalance)) {


//               const leaveBalances = {};

//               balanceData.message.leaveTypesWithBalance.forEach(leaveType => {
//                 const type = leaveType.leave_type.toLowerCase();

//                 leaveBalances[type] = {
//                   total: leaveType.allocated_days,
//                   used: leaveType.used_days,
//                   remaining: leaveType.remaining
//                 };
//               });
//               statistics = leaveBalances;
//             } else {
//               console.warn('Leave balance data is not in the expected format:', balanceData);
//               statistics = {};
//             }
//           } catch (balanceError) {
//             console.error('Error fetching leave balance:', balanceError);
//             if (balanceError.response && balanceError.response.status === 403) {
//               setOpenTokenExpirePopup(true);
//             }
//             statistics = {};
//           }

//           return {
//             id: request.id,
//             userId: request.user_id,
//             name: `${request.first_name} ${request.last_name}`,
//             avatar: `${request.first_name.charAt(0)}${request.last_name.charAt(0)}`,
//             workingIn: request.team,
//             leaveType: request.leave_type,
//             reason: request.reason,
//             status: request.status,
//             duration: request.actual_leave_days.toString(),
//             statistics: statistics,
//             startDate: request.start_date || "2023-06-01",
//             endDate: request.end_date || "2023-06-05"
//           };
//         }));

//         setLeaveRequests(transformedData);
//       } else {
//         throw new Error(response.data.message?.msg || 'Failed to fetch leave requests');
//       }
//     } catch (error) {
//       console.error('Error in fetchLeaveRequests:', error);
//       setError(error.message);
//       if (error.message.includes('authentication') || error.message.includes('session') ||
//           error.message.includes('token') || error.message.includes('User ID')) {
//         setSnackbar({
//           open: true,
//           message: error.message,
//           severity: 'error',
//           action: (
//             <Button color="inherit" size="small" onClick={() => {
//               window.location.href = '/login';
//             }}>
//               Login
//             </Button>
//           )
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: error.message || 'Failed to load leave requests',
//           severity: 'error'
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaveRequests(currentPage, statusFilter);
//     fetchLeaveTypes();
//   }, [currentPage, statusFilter]);


//   const fetchLeaveTypes = async () => {
//     setLoadingLeaveTypes(true);
//     setLeaveTypesError('');

//     try {
//       const response = await axios(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${organizationId}`, token));

//       if (response.data.statusCode === 200) {
//         setLeaveTypes(response.data.message.leaveTypes);
//       } else {
//         throw new Error(response.data.message?.msg || 'Failed to fetch leave types');
//       }
//     } catch (error) {
//       console.error('Error fetching leave types:', error);
//       setLeaveTypesError('Failed to load leave types. Please try again.');
//       if (error.response && error.response.status === 403) {
//         setOpenTokenExpirePopup(true);
//       }
//     } finally {
//       setLoadingLeaveTypes(false);
//     }
//   };

//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//   };


//   const handleStatusFilterChange = (event) => {
//     setStatusFilter(event.target.value);
//     setCurrentPage(1);
//   };


//   const fetchEmployeeLeaveBalance = async (userId) => {
//     setLoadingLeaveBalance(true);
//     setLeaveBalanceError('');

//     try {
//       if (!token) {
//         throw new Error('Authentication token not found. Please login again.');
//       }

//       const response = await axios(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`, token));
//       const balanceData = response.data;

//       if (balanceData.statusCode === 200 && balanceData.status === "SUCCESS" && 
//           balanceData.message && Array.isArray(balanceData.message.leaveTypesWithBalance)) {


//         const transformedBalance = balanceData.message.leaveTypesWithBalance.map(leaveType => ({
//           name: leaveType.leave_type.charAt(0).toUpperCase() + leaveType.leave_type.slice(1),
//           type: leaveType.leave_type.toLowerCase(),
//           total: leaveType.allocated_days,
//           used: leaveType.used_days,
//           remaining: leaveType.remaining,
//           percentage: leaveType.allocated_days > 0 ? 
//             Math.round((leaveType.used_days / leaveType.allocated_days) * 100) : 0
//         }));

//         setEmployeeLeaveBalance(transformedBalance);
//       } else {
//         throw new Error('Failed to fetch leave balance data');
//       }
//     } catch (error) {
//       console.error('Error fetching employee leave balance:', error);
//       setLeaveBalanceError('Failed to load leave balance. Please try again.');

//       if (error.response && error.response.status === 403) {
//         setOpenTokenExpirePopup(true);
//       }
//     } finally {
//       setLoadingLeaveBalance(false);
//     }
//   };


//   const handleViewBalance = (employee) => {
//     setSelectedEmployee(employee);
//     fetchEmployeeLeaveBalance(employee.userId);
//     fetchLeaveTypes(); 
//   };


//   const handleEmployeeRowClick = (employee) => {
//     setEmployeeDetailsData(employee);
//     setApprovalComment('');
//     setRejectionReason('');
//     setActionTab(0);
//     setOpenEmployeeDetails(true);
//     fetchLeaveTypes(); 
//   };


//   const handleLeaveApproval = async (employeeId, action, comment = '') => {
//     try {
//       setLoading(true);

//       if (!token) {
//         throw new Error('Authentication token not found. Please login again.');
//       }

//       const requestBody = {
//         comment: action === 'approve' ? comment : rejectionReason,
//         status: action === 'approve' ? "APPROVED" : "REJECTED"
//       };

//       const response = await axios(localAxiosPut(`/organization/approveLeave/${employeeId}`, requestBody, token));

//       if (response.data.statusCode !== 200) {
//         console.error('API Error Response:', response.data);
//         throw new Error(`Server returned ${response.status}: ${response.statusText}`);
//       }

//       const data = response.data;

//       if (data.statusCode === 401) {
//         throw new Error('Your session has expired. Please login again.');
//       }

//       if (data.statusCode !== 200) {
//         throw new Error(data.message || `Failed to ${action} leave request`);
//       }

//       setOpenEmployeeDetails(false);

//       setSnackbar({
//         open: true,
//         message: data.message || `Leave request ${action === 'approve' ? 'approved' : 'rejected'} successfully.`,
//         severity: 'success'
//       });

//       if (action === 'approve') {
//         setApprovalComment('');
//       } else {
//         setRejectionReason('');
//       }


//       fetchLeaveRequests(currentPage, statusFilter);

//     } catch (error) {
//       console.error('Error in handleLeaveApproval:', error);

//            if (error.message.includes('authentication') || error.message.includes('session') || 
//           error.message.includes('token')) {
//         setSnackbar({
//           open: true,
//           message: error.message,
//           severity: 'error',
//           action: (
//             <Button color="inherit" size="small" onClick={() => {
//               window.location.href = '/login';
//             }}>
//               Login
//             </Button>
//           )
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: error.message || `Failed to ${action} leave request`,
//           severity: 'error'
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleSubmitLeave = async () => {
//     try {
//       if (!leaveFormData.startDate || !leaveFormData.endDate ||
//           !leaveFormData.leaveType || !leaveFormData.reason) {
//         setSnackbar({
//           open: true,
//           message: 'Please fill all required fields',
//           severity: 'error'
//         });
//         return;
//       }

//       setLoading(true);
//       const token = localStorage.getItem('accessToken');
//       const userId = localStorage.getItem('userId');
//       const organizationId = localStorage.getItem('organizationId');
//       const reportingManagerId = localStorage.getItem('reportingmanagerId');
//       const locationId = localStorage.getItem('locationId');

//       if (!token || !userId || !organizationId || !reportingManagerId) {
//         throw new Error('Missing required authentication information. Please login again.');
//       }

//       const start = new Date(leaveFormData.startDate);
//       const end = new Date(leaveFormData.endDate);
//       const duration = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

//       const requestData = {
//         user_id: parseInt(userId),
//         organization_id: parseInt(organizationId),
//         start_date: leaveFormData.startDate,
//         end_date: leaveFormData.endDate,
//         leave_type_id: parseInt(leaveFormData.leaveType),
//         reason: leaveFormData.reason,
//         report_manager_id: parseInt(reportingManagerId),
//         leave_duration_type: "FULL_DAY",
//         location_id: parseInt(locationId)
//       };

//       const response = await axios(localAxiosToken('/organization/createLeave', requestData, token));

//       if (response.data.statusCode === 401) {
//         throw new Error('Your session has expired. Please login again.');
//       }

//       if (response.data.statusCode !== 200) {
//         throw new Error(response.data.message?.msg || 'Failed to submit leave request');
//       }


//       const balanceResponse = await axios(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`, token));
//       const balanceData = balanceResponse.data;

//       let statistics = {};
//       if (balanceData.statusCode === 200 && balanceData.status === "SUCCESS" && 
//           balanceData.message && Array.isArray(balanceData.message.leaveTypesWithBalance)) {

//         const leaveBalances = {};
//         balanceData.message.leaveTypesWithBalance.forEach(leaveType => {
//           const type = leaveType.leave_type.toLowerCase();

//           leaveBalances[type] = {
//             total: leaveType.allocated_days,
//             used: leaveType.used_days,
//             remaining: leaveType.remaining
//           };
//         });
//         statistics = leaveBalances;
//       } else {
//         console.warn('Leave balance data is not in the expected format:', balanceData);
//         statistics = {};
//       }

//       setOpenApplyLeave(false);
//       setLeaveFormData({
//         startDate: '',
//         endDate: '',
//         leaveType: '',
//         reason: '',
//         manager: '',
//       });

//       setSnackbar({
//         open: true,
//         message: 'Leave request submitted successfully',
//         severity: 'success'
//       });


//       fetchLeaveRequests(currentPage, statusFilter);

//     } catch (error) {
//       console.error('Error in handleSubmitLeave:', error);

//       if (error.message.includes('authentication') || error.message.includes('session') ||
//           error.message.includes('token') || error.message.includes('User ID')) {
//         setSnackbar({
//           open: true,
//           message: error.message,
//           severity: 'error',
//           action: (
//             <Button color="inherit" size="small" onClick={() => {
//               window.location.href = '/login';
//             }}>
//               Login
//             </Button>
//           )
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: error.message || 'Failed to submit leave request',
//           severity: 'error'
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };


//   const pendingRequestsCount = leaveRequests.filter(req => req.status === 'PENDING').length;
//   const pendingPercentage = leaveRequests.length > 0 
//     ? (pendingRequestsCount / leaveRequests.length) * 100 
//     : 0;

//   const formatDate = (isoString) => {
//     const date = new Date(isoString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//     });
//   };


//   const getDayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//     return days[date.getDay()];
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         mb: 4,
//         backgroundColor: '#fff',
//         padding: '20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//       }}>
//         <Box>
//           <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1a1a1a', mb: 1 }}>
//             Manage Leaves
//           </Typography>
//           <Typography variant="subtitle1" color="text.secondary">
//             Track and manage employee leave requests
//           </Typography>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 2 }}>
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={() => setIsMyLeavesPopupOpen(true)}
//             sx={{
//               backgroundColor: '#6a1b9a',
//               color: 'white',
//               borderRadius: '8px',
//               padding: '10px 24px',
//               '&:hover': {
//                 backgroundColor: '#4a148c',
//                 boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//               },
//             }}
//           >
//             My Leaves
//           </Button>
//           <Button
//             variant="contained"
//             startIcon={<AddIcon />}
//             onClick={() => setOpenApplyLeave(true)}
//             sx={{
//               backgroundColor: '#1976d2',
//               color: 'white',
//               borderRadius: '8px',
//               padding: '10px 24px',
//               '&:hover': {
//                 backgroundColor: '#1565c0',
//                 boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//               },
//             }}
//           >
//             Apply Leave
//           </Button>
//         </Box>
//       </Box>


//       <Grid container spacing={3} sx={{ mb: 6 }}>
//         <Grid item xs={12} md={6}>
//           <Card sx={{ 
//             height: '100%', 
//             backgroundColor: '#E3F2FD',
//             boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
//             borderRadius: '16px',
//           }}>
//             <CardContent sx={{ p: 3 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                 <Badge badgeContent={pendingRequestsCount} color="error">
//                   <EventNoteIcon sx={{ fontSize: 48, color: '#1565C0' }} />
//                 </Badge>
//                 <Box sx={{ ml: 2 }}>
//                   <Typography variant="h6" sx={{ color: '#1565C0', fontWeight: 'bold' }}>
//                     Employee Leave Requests
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {pendingRequestsCount} pending requests
//                   </Typography>
//                 </Box>
//               </Box>
//               {loading ? (
//                 <LinearProgress 
//                   sx={{ 
//                     height: 8, 
//                     borderRadius: 4,
//                     backgroundColor: '#e3f2fd',
//                   }} 
//                 />
//               ) : (
//                 <LinearProgress 
//                   variant="determinate" 
//                   value={pendingPercentage} 
//                   sx={{ 
//                     height: 8, 
//                     borderRadius: 4,
//                     backgroundColor: '#e3f2fd',
//                     '& .MuiLinearProgress-bar': {
//                       backgroundColor: '#1565C0',
//                     }
//                   }} 
//                 />
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Card sx={{ 
//             height: '100%', 
//             backgroundColor: '#E0F2F1',
//             boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
//             borderRadius: '16px',
//           }}>
//             <CardContent sx={{ p: 3 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                 <DescriptionIcon sx={{ fontSize: 48, color: '#00796B' }} />
//                 <Box sx={{ ml: 2 }}>
//                   <Typography variant="h6" sx={{ color: '#00796B', fontWeight: 'bold' }}>
//                     Leave Status Overview
//                   </Typography>
//                 </Box>
//               </Box>

//               {loading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                   <CircularProgress size={40} sx={{ color: '#00796B' }} />
//                 </Box>
//               ) : leaveRequests.length === 0 ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px' }}>
//                   <Typography variant="body1" color="text.secondary">
//                     No leave requests to display
//                   </Typography>
//                 </Box>
//               ) : (
//                 <>
//                   <Box sx={{ mt: 3 }}>
//                     <Typography variant="body2" sx={{ color: '#00796B', fontWeight: 'bold', mb: 2 }}>
//                       Leave Status Distribution
//                     </Typography>
//                     <Box sx={{ mb: 1 }}>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                         <Typography variant="caption" color="text.secondary">Pending</Typography>
//                         <Typography variant="caption" fontWeight="bold" color="#F57C00">
//                           {leaveRequests.filter(req => req.status === 'PENDING').length} 
//                           ({((leaveRequests.filter(req => req.status === 'PENDING').length / leaveRequests.length) * 100).toFixed(1)}%)
//                         </Typography>
//                       </Box>
//                       <LinearProgress
//                         variant="determinate"
//                         value={(leaveRequests.filter(req => req.status === 'PENDING').length / leaveRequests.length) * 100}
//                         sx={{
//                           height: 4,
//                           borderRadius: 2,
//                           backgroundColor: alpha('#F57C00', 0.2),
//                           '& .MuiLinearProgress-bar': {
//                             backgroundColor: '#F57C00',
//                           }
//                         }}
//                       />
//                     </Box>

//                     <Box>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                         <Typography variant="caption" color="text.secondary">Approved</Typography>
//                         <Typography variant="caption" fontWeight="bold" color="#2E7D32">
//                           {leaveRequests.filter(req => req.status === 'APPROVED').length}
//                           ({((leaveRequests.filter(req => req.status === 'APPROVED').length / leaveRequests.length) * 100).toFixed(1)}%)
//                         </Typography>
//                       </Box>
//                       <LinearProgress
//                         variant="determinate"
//                         value={(leaveRequests.filter(req => req.status === 'APPROVED').length / leaveRequests.length) * 100}
//                         sx={{
//                           height: 4,
//                           borderRadius: 2,
//                           backgroundColor: alpha('#2E7D32', 0.2),
//                           '& .MuiLinearProgress-bar': {
//                             backgroundColor: '#2E7D32',
//                           }
//                         }}
//                       />
//                     </Box>

//                     {leaveRequests.filter(req => req.status === 'REJECTED').length > 0 && (
//                       <Box sx={{ mt: 1 }}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                           <Typography variant="caption" color="text.secondary">Rejected</Typography>
//                           <Typography variant="caption" fontWeight="bold" color="#C62828">
//                             {leaveRequests.filter(req => req.status === 'REJECTED').length}
//                             ({((leaveRequests.filter(req => req.status === 'REJECTED').length / leaveRequests.length) * 100).toFixed(1)}%)
//                           </Typography>
//                         </Box>
//                         <LinearProgress
//                           variant="determinate"
//                           value={(leaveRequests.filter(req => req.status === 'REJECTED').length / leaveRequests.length) * 100}
//                           sx={{
//                             height: 4,
//                             borderRadius: 2,
//                             backgroundColor: alpha('#C62828', 0.2),
//                             '& .MuiLinearProgress-bar': {
//                               backgroundColor: '#C62828',
//                             }
//                           }}
//                         />
//                       </Box>
//                     )}
//                   </Box>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>


//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//           Leave Requests
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="status-filter-label">Status Filter</InputLabel>
//                       <Select
//               labelId="status-filter-label"
//               id="status-filter"
//               value={statusFilter}
//               label="Status Filter"
//               onChange={handleStatusFilterChange}
//             >
//               <MenuItem value="ALL">All Requests</MenuItem>
//               <MenuItem value="PENDING">PENDING</MenuItem>
//               <MenuItem value="APPROVED">APPROVED</MenuItem>
//               <MenuItem value="REJECTED">REJECTED</MenuItem>
//             </Select>
//           </FormControl>
//         </Box>


//         <TableContainer component={Paper} sx={{ borderRadius: '12px', boxShadow: 3 }}>
//           <Table>
//             <TableHead sx={{ 
//               '& .MuiTableCell-head': {
//                 backgroundColor: '#1976d2',
//                 color: 'white',
//                 fontWeight: 'bold',
//                 fontSize: '1rem',
//                 padding: '16px',
//               },
//             }}>
//               <TableRow>
//                 <TableCell>Employee Name</TableCell>
//                 <TableCell>Team</TableCell>
//                 <TableCell>Leave Type</TableCell>
//                 <TableCell>Reason for Leave</TableCell>
//                 <TableCell>Duration</TableCell>
//                 <TableCell>Start Date</TableCell> 
//                 <TableCell>End Date</TableCell>
//                 <TableCell>Status</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center">
//                     <LinearProgress sx={{ my: 2 }} />
//                     <Typography variant="body2" color="text.secondary">
//                       Loading leave requests...
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : error ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center">
//                     <Typography variant="body2" color="error">
//                       {error}
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : leaveRequests.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center">
//                     <Typography variant="body2" color="text.secondary">
//                       No leave requests found
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 leaveRequests.map((request) => (
//                   <TableRow 
//                     key={request.id} 
//                     onClick={() => handleEmployeeRowClick(request)}
//                     sx={{
//                       '&:nth-of-type(odd)': {
//                         backgroundColor: '#f8f9fa',
//                       },
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                         transition: 'background-color 0.2s ease',
//                       },
//                       cursor: 'pointer',
//                     }}
//                   >
//                     <TableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Avatar sx={{ mr: 2, bgcolor: '#1976d2' }}>{request.avatar}</Avatar>
//                         <Box>
//                           <Typography variant="subtitle2">{request.name}</Typography>
//                         </Box>
//                       </Box>
//                     </TableCell>
//                     <TableCell>{request.workingIn}</TableCell>
//                     <TableCell>{request.leaveType}</TableCell>
//                     <TableCell>{request.reason}</TableCell>
//                     <TableCell>{request.duration} day(s)</TableCell>
//                     <TableCell>{formatDate(request.startDate)}</TableCell> 
//                     <TableCell>{formatDate(request.endDate)}</TableCell>
//                     <TableCell>
//                       <Chip 
//                         label={request.status} 
//                         sx={{
//                           backgroundColor: request.status === 'PENDING' ? '#fff3e0' : 
//                                           request.status === 'APPROVED' ? '#e8f5e9' : '#ffebee',
//                           color: request.status === 'PENDING' ? '#f57c00' : 
//                                 request.status === 'APPROVED' ? '#2e7d32' : '#c62828',
//                           fontWeight: 'bold',
//                         }}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>


//         {!loading && leaveRequests.length > 0 && (
//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
//             <Pagination 
//               count={totalPages} 
//               page={currentPage} 
//               onChange={handlePageChange}
//               color="primary"
//               size="large"
//               showFirstButton
//               showLastButton
//               sx={{
//                 '& .MuiPaginationItem-root': {
//                   fontSize: '1rem',
//                 },
//               }}
//             />
//           </Box>
//         )}


//         <Dialog
//           open={isMyLeavesPopupOpen}
//           onClose={() => setIsMyLeavesPopupOpen(false)}
//           maxWidth="md"
//           fullWidth
//           PaperProps={{
//             style: {
//               borderRadius: '16px',
//             },
//           }}
//         >
//           <Box
//             sx={{
//               background: 'linear-gradient(90deg, #6a1b9a 0%, #8e24aa 100%)',
//               p: 3,
//               color: 'white',
//               borderTopLeftRadius: '16px',
//               borderTopRightRadius: '16px',
//             }}
//           >
//             <Typography variant="h5" fontWeight="500">
//               My Leave History
//             </Typography>
//           </Box>
//           <DialogContent sx={{ p: 3 }}>
//             <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Box sx={{ display: 'flex', gap: 2 }}>
//                 <FormControl sx={{ minWidth: 120 }}>
//                   <InputLabel id="year-select-label">Year</InputLabel>
//                   <Select
//                     labelId="year-select-label"
//                     value={selectedYear}
//                     onChange={(e) => {
//                       if (e.target.name === 'year') {
//                         setSelectedYear(parseInt(e.target.value));
//                       }
//                     }}
//                     name="year"
//                     sx={{ borderRadius: '8px' }}
//                   >
//                     {[2023, 2024, 2025].filter(year => year <= new Date().getFullYear() + 1).map((year) => (
//                       <MenuItem key={year} value={year}>{year}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl sx={{ minWidth: 120 }}>
//                   <InputLabel id="month-select-label">Month</InputLabel>
//                   <Select
//                     labelId="month-select-label"
//                     value={selectedMonth}
//                     onChange={(e) => {
//                       if (e.target.name === 'month') {
//                         setSelectedMonth(parseInt(e.target.value));
//                       }
//                     }}
//                     name="month"
//                     sx={{ borderRadius: '8px' }}
//                   >
//                     {[
//                       { value: 1, label: 'January' },
//                       { value: 2, label: 'February' },
//                       { value: 3, label: 'March' },
//                       { value: 4, label: 'April' },
//                       { value: 5, label: 'May' },
//                       { value: 6, label: 'June' },
//                       { value: 7, label: 'July' },
//                       { value: 8, label: 'August' },
//                       { value: 9, label: 'September' },
//                       { value: 10, label: 'October' },
//                       { value: 11, label: 'November' },
//                       { value: 12, label: 'December' }
//                     ]
//                     .filter(month => 
//                       selectedYear < new Date().getFullYear() || 
//                       month.value <= new Date().getMonth() + 1
//                     )
//                     .map((month) => (
//                       <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Box>
//             {loadingMyLeaves ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//                 <CircularProgress />
//               </Box>
//             ) : myLeavesError ? (
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {myLeavesError}
//               </Alert>
//             ) : (
//               <>
//                 {myLeaves.length > 0 ? (
//                   <Grid container spacing={2}>
//                     {myLeaves.map((leave, index) => (
//                       <Grid item xs={12} sm={6} md={4} key={leave.id || index}>
//                         <Card 
//                           sx={{ 
//                             height: '100%', 
//                             display: 'flex', 
//                             flexDirection: 'column',
//                             boxShadow: 3,
//                             borderRadius: 2,
//                             transition: 'transform 0.2s, box-shadow 0.2s',
//                             '&:hover': {
//                               transform: 'translateY(-4px)',
//                               boxShadow: 6,
//                             }
//                           }}
//                         >
//                           <Box 
//                             sx={{ 
//                               p: 2, 
//                               backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' : 
//                                             leave.leave_type?.includes('Casual') ? '#e8f5e9' : 
//                                             leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
//                               borderBottom: '1px solid #eee'
//                             }}
//                           >
//                             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                               <Chip
//                                 label={leave.leave_type || "N/A"}
//                                 size="small"
//                                 sx={{ 
//                                   backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' : 
//                                                 leave.leave_type?.includes('Casual') ? '#e8f5e9' : 
//                                                 leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
//                                   color: leave.leave_type?.includes('Sick') ? '#c62828' : 
//                                       leave.leave_type?.includes('Casual') ? '#2e7d32' : 
//                                       leave.leave_type?.includes('Paid') ? '#1565c0' : '#6a1b9a',
//                                   fontWeight: 500,
//                                   border: '1px solid',
//                                   borderColor: leave.leave_type?.includes('Sick') ? '#ef9a9a' : 
//                                               leave.leave_type?.includes('Casual') ? '#a5d6a7' : 
//                                               leave.leave_type?.includes('Paid') ? '#90caf9' : '#ce93d8',
//                                 }}
//                               />
//                               <Chip
//                                 label={leave.status?.toUpperCase() || "N/A"}
//                                 size="small"
//                                 icon={
//                                   leave.status?.toLowerCase() === 'approved' ? <CheckCircleIcon /> :
//                                   leave.status?.toLowerCase() === 'rejected' ? <CancelIcon /> :
//                                   <PendingActions />
//                                 }
//                                 color={
//                                   leave.status?.toLowerCase() === 'approved' ? 'success' :
//                                   leave.status?.toLowerCase() === 'rejected' ? 'error' :
//                                   'warning'
//                                 }
//                                 sx={{ fontWeight: 500 }}
//                               />
//                             </Box>
//                           </Box>
//                           <CardContent sx={{ flexGrow: 1, p: 2 }}>
//                             <Box sx={{ mb: 2 }}>
//                               <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                 <CalendarMonth sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                 <Typography variant="subtitle2" color="text.secondary">
//                                   Duration
//                                 </Typography>
//                               </Box>
//                               <Box sx={{ pl: 3.5 }}>
//                                 <Typography variant="body2" sx={{ mb: 0.5 }}>
//                                   <strong>From:</strong> {formatDate(leave.start_date)}
//                                   <Typography variant="caption" sx={{ color: 'text.secondary', ml: 1 }}>
//                                     ({getDayOfWeek(leave.start_date)})
//                                   </Typography>
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>To:</strong> {formatDate(leave.end_date)}
//                                   <Typography variant="caption" sx={{ color: 'text.secondary', ml: 1 }}>
//                                     ({getDayOfWeek(leave.end_date)})
//                                   </Typography>
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             <Box sx={{ mb: 2 }}>
//                               <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                 <DescriptionIcon sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                 <Typography variant="subtitle2" color="text.secondary">
//                                   Reason
//                                 </Typography>
//                               </Box>
//                               <Typography 
//                                 variant="body2" 
//                                 sx={{ 
//                                   pl: 3.5,
//                                   overflow: 'hidden', 
//                                   textOverflow: 'ellipsis', 
//                                   display: '-webkit-box',
//                                   WebkitLineClamp: 2,
//                                   WebkitBoxOrient: 'vertical'
//                                 }}
//                               >
//                                 {leave.reason || 'N/A'}
//                               </Typography>
//                             </Box>

//                             <Box>
//                               <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                 <Comment sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                 <Typography variant="subtitle2" color="text.secondary">
//                                   Comments
//                                 </Typography>
//                               </Box>
//                               <Typography 
//                                 variant="body2" 
//                                 sx={{ 
//                                   pl: 3.5,
//                                   overflow: 'hidden', 
//                                   textOverflow: 'ellipsis', 
//                                   display: '-webkit-box',
//                                   WebkitLineClamp: 2,
//                                   WebkitBoxOrient: 'vertical'
//                                 }}
//                               >
//                                 {leave.comments || 'N/A'}
//                               </Typography>
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 ) : (
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
//                     <EventNoteIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
//                     <Typography variant="h6" color="text.secondary">
//                       No leave records found
//                     </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                       You don't have any leave records for the selected period
//                     </Typography>
//                   </Box>
//                 )}
//               </>
//             )}
//           </DialogContent>
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'flex-end',
//               p: 3,
//               background: '#f8f9fa',
//               borderTop: '1px solid #eee',
//               borderBottomLeftRadius: '16px',
//               borderBottomRightRadius: '16px',
//             }}
//           >
//             <Button
//               onClick={() => setIsMyLeavesPopupOpen(false)}
//               variant="contained"
//               sx={{
//                 borderRadius: 8,
//                 px: 3,
//                 py: 1,
//                 backgroundColor: '#6a1b9a',
//                 '&:hover': {
//                   backgroundColor: '#4a148c'
//                 }
//               }}
//             >
//               Close
//             </Button>
//           </Box>
//         </Dialog>


//         <Dialog
//           open={openApplyLeave}
//           onClose={() => setOpenApplyLeave(false)}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             style: {
//               borderRadius: '16px',
//             },
//           }}
//         >
//           <Box
//             sx={{
//               background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
//               p: 3,
//               color: 'white',
//               borderTopLeftRadius: '16px',
//               borderTopRightRadius: '16px',
//             }}
//           >
//             <Typography variant="h5" fontWeight="500">
//               Apply for Leave
//             </Typography>
//           </Box>
//           <DialogContent sx={{ p: 3 }}>
//             <Box component="form" sx={{ mt: 2 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Start Date"
//                     type="date"
//                     value={leaveFormData.startDate}
//                     onChange={(e) => setLeaveFormData({ ...leaveFormData, startDate: e.target.value })}
//                     InputLabelProps={{ shrink: true }}
//                     required
//                     sx={{ mb: 2 }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="End Date"
//                     type="date"
//                     value={leaveFormData.endDate}
//                     onChange={(e) => setLeaveFormData({ ...leaveFormData, endDate: e.target.value })}
//                     InputLabelProps={{ shrink: true }}
//                     required
//                     sx={{ mb: 2 }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl fullWidth required sx={{ mb: 2 }}>
//                     <InputLabel>Leave Type</InputLabel>
//                     <Select
//                       value={leaveFormData.leaveType}
//                       onChange={(e) => setLeaveFormData({ ...leaveFormData, leaveType: e.target.value })}
//                       label="Leave Type"
//                     >
//                       {loadingLeaveTypes ? (
//                         <MenuItem disabled>Loading leave types...</MenuItem>
//                       ) : leaveTypesError ? (
//                         <MenuItem disabled>Error loading leave types</MenuItem>
//                       ) : leaveTypes.length === 0 ? (
//                         <MenuItem disabled>No leave types available</MenuItem>
//                       ) : (
//                         leaveTypes.map((type) => (
//                           <MenuItem key={type.id} value={type.id.toString()}>
//                             {type.leave_type}
//                           </MenuItem>
//                         ))
//                       )}
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Reason for Leave"
//                     multiline
//                     rows={4}
//                     value={leaveFormData.reason}
//                     onChange={(e) => setLeaveFormData({ ...leaveFormData, reason: e.target.value })}
//                     required
//                     sx={{ mb: 2 }}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           </DialogContent>
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'flex-end',
//               p: 3,
//               gap: 2,
//               background: '#f8f9fa',
//               borderTop: '1px solid #eee',
//               borderBottomLeftRadius: '16px',
//               borderBottomRightRadius: '16px',
//             }}
//           >
//             <Button
//               onClick={() => setOpenApplyLeave(false)}
//               variant="outlined"
//               sx={{ borderRadius: 8, px: 3, py: 1 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSubmitLeave}
//               variant="contained"
//               sx={{
//                 borderRadius: 8,
//                 px: 3,
//                 py: 1,
//                 backgroundColor: '#1976d2',
//                 '&:hover': {
//                   backgroundColor: '#1565c0'
//                 }
//               }}
//             >
//               Submit
//             </Button>
//           </Box>
//         </Dialog>


//         <Dialog
//           open={openEmployeeDetails}
//           onClose={() => setOpenEmployeeDetails(false)}
//           maxWidth="md"
//           fullWidth
//           PaperProps={{
//             style: {
//               borderRadius: '16px',
//             },
//           }}
//         >
//           {employeeDetailsData && (
//             <>
//               <Box
//                 sx={{
//                   background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
//                   p: 3,
//                   color: 'white',
//                   borderTopLeftRadius: '16px',
//                   borderTopRightRadius: '16px',
//                 }}
//               >
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <Avatar sx={{ width: 56, height: 56, bgcolor: '#1565c0', mr: 2 }}>
//                     {employeeDetailsData.avatar}
//                   </Avatar>
//                   <Box>
//                     <Typography variant="h5" fontWeight="500">
//                       {employeeDetailsData.name}
//                     </Typography>
//                     <Typography variant="subtitle1">
//                       {employeeDetailsData.workingIn}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//               <DialogContent sx={{ p: 3 }}>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} md={6}>
//                     <Card sx={{ mb: 3, boxShadow: 2, borderRadius: 2 }}>
//                       <CardContent>
//                         <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
//                           Leave Request Details
//                         </Typography>

//                         <Box sx={{ mb: 2 }}>
//                           <Typography variant="subtitle2" color="text.secondary">
//                             Leave Type
//                           </Typography>
//                           <Typography variant="body1">
//                             {employeeDetailsData.leaveType}
//                           </Typography>
//                         </Box>

//                         <Box sx={{ mb: 2 }}>
//                           <Typography variant="subtitle2" color="text.secondary">
//                             Duration
//                           </Typography>
//                           <Typography variant="body1">
//                             {employeeDetailsData.duration} day(s)
//                           </Typography>
//                         </Box>

//                         <Box sx={{ mb: 2 }}>
//                           <Typography variant="subtitle2" color="text.secondary">
//                             Start Date
//                           </Typography>
//                           <Typography variant="body1">
//                             {formatDate(employeeDetailsData.startDate)}
//                           </Typography>
//                         </Box>

//                         <Box sx={{ mb: 2 }}>
//                           <Typography variant="subtitle2" color="text.secondary">
//                             End Date
//                           </Typography>
//                           <Typography variant="body1">
//                             {formatDate(employeeDetailsData.endDate)}
//                           </Typography>
//                         </Box>

//                         <Box>
//                           <Typography variant="subtitle2" color="text.secondary">
//                             Reason
//                           </Typography>
//                           <Typography variant="body1">
//                             {employeeDetailsData.reason}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>

//                     <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
//                       <CardContent>
//                         <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
//                           Leave Balance
//                         </Typography>

//                         {loadingLeaveBalance ? (
//                           <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                             <CircularProgress size={30} />
//                           </Box>
//                         ) : leaveBalanceError ? (
//                           <Alert severity="error" sx={{ mb: 2 }}>
//                             {leaveBalanceError}
//                           </Alert>
//                         ) : (
//                           Object.entries(employeeDetailsData.statistics).map(([type, data]) => (
//                             <Box key={type} sx={{ mb: type !== Object.keys(employeeDetailsData.statistics).pop() ? 2 : 0 }}>
//                               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                                 <Typography variant="subtitle2">
//                                   {type.charAt(0).toUpperCase() + type.slice(1)} Leave
//                                 </Typography>
//                                 <Typography variant="subtitle2">
//                                   {data.remaining}/{data.total} days remaining
//                                 </Typography>
//                               </Box>
//                               <LinearProgress
//                                 variant="determinate"
//                                 value={(data.used / data.total) * 100}
//                                 sx={{
//                                   height: 8,
//                                   borderRadius: 4,
//                                   mb: 1,
//                                   backgroundColor: alpha('#1976d2', 0.2),
//                                   '& .MuiLinearProgress-bar': {
//                                     backgroundColor: '#1976d2',
//                                   }
//                                 }}
//                               />
//                               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <Typography variant="caption" color="text.secondary">
//                                   Total: {data.total} days
//                                 </Typography>
//                                 <Typography variant="caption" color="text.secondary">
//                                   Used: {data.used} days
//                                 </Typography>
//                                 <Typography variant="caption" color="text.secondary">
//                                   Remaining: {data.remaining} days
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           ))
//                         )}
//                       </CardContent>
//                     </Card>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
//                       <CardContent>
//                         <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
//                           Action
//                         </Typography>

//                         <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
//                           <Tabs value={actionTab} onChange={(event, newValue) => setActionTab(newValue)} aria-label="action tabs">
//                             <Tab 
//                               label="Approve" 
//                               sx={{ 
//                                 color: actionTab === 0 ? '#2e7d32' : 'inherit',
//                                 '&.Mui-selected': { color: '#2e7d32' }
//                               }}
//                             />
//                             <Tab 
//                               label="Reject" 
//                               sx={{ 
//                                 color: actionTab === 1 ? '#c62828' : 'inherit',
//                                 '&.Mui-selected': { color: '#c62828' }
//                               }}
//                             />
//                           </Tabs>
//                         </Box>

//                         {actionTab === 0 && (
//                           <Box>
//                             <TextField
//                               fullWidth
//                               label="Approval Comments (Optional)"
//                               multiline
//                               rows={4}
//                               value={approvalComment}
//                               onChange={(e) => setApprovalComment(e.target.value)}
//                               sx={{ mb: 3 }}
//                             />

//                             <Button
//                               fullWidth
//                               variant="contained"
//                               color="success"
//                               onClick={() => handleLeaveApproval(employeeDetailsData.id, 'approve', approvalComment)}
//                               disabled={employeeDetailsData.status !== 'PENDING'}
//                               sx={{
//                                 py: 1.5,
//                                 borderRadius: 2,
//                                 fontWeight: 'bold',
//                                 boxShadow: 2,
//                               }}
//                             >
//                               Approve Leave Request
//                             </Button>

//                             {employeeDetailsData.status !== 'PENDING' && (
//                               <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
//                                 This request has already been {employeeDetailsData.status.toLowerCase()}
//                               </Typography>
//                             )}
//                           </Box>
//                         )}

//                         {actionTab === 1 && (
//                           <Box>
//                             <TextField
//                               fullWidth
//                               label="Rejection Reason"
//                               multiline
//                               rows={4}
//                               value={rejectionReason}
//                               onChange={(e) => setRejectionReason(e.target.value)}
//                               required
//                               error={rejectionReason.trim() === ''}
//                               helperText={rejectionReason.trim() === '' ? 'Rejection reason is required' : ''}
//                               sx={{ mb: 3 }}
//                             />

//                             <Button
//                               fullWidth
//                               variant="contained"
//                               color="error"
//                               onClick={() => handleLeaveApproval(employeeDetailsData.id, 'reject')}
//                               disabled={employeeDetailsData.status !== 'PENDING' || rejectionReason.trim() === ''}
//                               sx={{
//                                 py: 1.5,
//                                 borderRadius: 2,
//                                 fontWeight: 'bold',
//                                 boxShadow: 2,
//                               }}
//                             >
//                               Reject Leave Request
//                             </Button>

//                             {employeeDetailsData.status !== 'PENDING' && (
//                               <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
//                                 This request has already been {employeeDetailsData.status.toLowerCase()}
//                               </Typography>
//                             )}
//                           </Box>
//                         )}
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   p: 3,
//                   background: '#f8f9fa',
//                   borderTop: '1px solid #eee',
//                   borderBottomLeftRadius: '16px',
//                   borderBottomRightRadius: '16px',
//                 }}
//               >
//                 <Button
//                   onClick={() => setOpenEmployeeDetails(false)}
//                   variant="outlined"
//                   sx={{ borderRadius: 8, px: 3, py: 1 }}
//                 >
//                   Close
//                 </Button>
//               </Box>
//             </>
//           )}
//         </Dialog>


//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//         >
//           <Alert 
//             onClose={() => setSnackbar({ ...snackbar, open: false })} 
//             severity={snackbar.severity} 
//             sx={{ width: '100%', boxShadow: 3, borderRadius: 2 }}
//             action={snackbar.action}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>


//         <Modal
//           open={openTokenExpirePopup}
//           onClose={handleCloseTokenExpirePopup}
//           aria-labelledby="token-expire-modal-title"
//           aria-describedby="token-expire-modal-description"
//         >
//           <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
//         </Modal>
//       </Box>
//     );
// };

// export default EmployeeLeaves;









import React, { useState, useEffect } from 'react';
import {
  Box, Modal, Typography, Card, CardContent, Button, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, MenuItem, Grid, Tooltip, Badge, Avatar, Chip,
  Select, FormControl, InputLabel, LinearProgress, Alert, Snackbar,
  CircularProgress, Divider, Tabs, Tab, Pagination
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Person as PersonIcon,
  EventNote as EventNoteIcon,
  Add as AddIcon,
  Work as WorkIcon,
  DateRange as DateRangeIcon,
  Description as DescriptionIcon,
  Timeline as TimelineIcon,
  SupervisorAccount as SupervisorIcon,
  Visibility as VisibilityIcon,
  FilterList,
  Search,
  Sort,
  ArrowDownward,
  ArrowUpward,
  CalendarMonth,
  Comment,
  PendingActions,
} from '@mui/icons-material';
import { styled, alpha } from '@mui/material/styles';
import axios from 'axios';
import { axiosInstance, localAxiosGet, localAxiosPut, localAxiosToken } from '../../../Axios/axios';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import EmployeeLeaveManagement from '../../Employee/Leaves/EmployeeLeaveManagement';

const StyledCard = styled(Card)(({ theme, type }) => ({
  height: '100%',
  backgroundColor: type === 'requests' ? '#E3F2FD' : '#FFF3E0',
  boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 12px 20px rgba(0,0,0,0.15)',
  },
  cursor: 'pointer',
  borderRadius: '16px',
}));

const EmployeeLeaves = () => {
  const [openApplyLeave, setOpenApplyLeave] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [leaveFormData, setLeaveFormData] = useState({
    startDate: '',
    endDate: '',
    leaveType: '',
    reason: '',
    manager: '',
  });

  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const navigate = useNavigate();

  const [isMyLeavesPopupOpen, setIsMyLeavesPopupOpen] = useState(false);
  const [myLeaves, setMyLeaves] = useState([]);
  const [loadingMyLeaves, setLoadingMyLeaves] = useState(false);
  const [myLeavesError, setMyLeavesError] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [sortBy, setSortBy] = useState('start_date');
  const [sortOrder, setSortOrder] = useState('asc');
  const [openEmployeeDetails, setOpenEmployeeDetails] = useState(false);
  const [employeeDetailsData, setEmployeeDetailsData] = useState(null);
  const [approvalComment, setApprovalComment] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [actionTab, setActionTab] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [statusFilter, setStatusFilter] = useState('ALL');

  const [employeeLeaveBalance, setEmployeeLeaveBalance] = useState([]);
  const [loadingLeaveBalance, setLoadingLeaveBalance] = useState(false);
  const [leaveBalanceError, setLeaveBalanceError] = useState('');
  const [showMyLeavesWindow, setShowMyLeavesWindow] = useState(false)

  const token = localStorage.getItem('accessToken');
  const organizationId = localStorage.getItem('organizationId');
  const reportingmanagerId = localStorage.getItem('reportingmanagerId');

  


  const handleCloseTokenExpirePopup = () => {
    setOpenTokenExpirePopup(false);
    navigate('/');
  };

  const fetchLeaveRequests = async (page = 1, status = 'ALL') => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const userId = localStorage.getItem('userId');
  
      if (!token) {
        throw new Error('Authentication token not found. Please login again.');
      }
      if (!userId) {
        throw new Error('User ID not found. Please login again.');
      }
  
      let url = `/organization/getLeaveRequestsByManager/${userId}?page=${page}&limit=${pageSize}&sortBy=updatedAt&sortOrder=desc`;
      
      if (status !== 'ALL') {
        url += `&status=${status}`;
      }
  
      const response = await axiosInstance(localAxiosGet(url));
  
      if (response.data.statusCode === 401) {
        throw new Error('Your session has expired. Please login again.');
      }
  
      if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
        const paginationData = response.data.message;
        setCurrentPage(paginationData.page);
        setTotalPages(paginationData.totalPages);
        setTotalRecords(paginationData.totalRecords);
  
        const transformedData = paginationData.data.map((request) => {
          return {
            id: request.id,
            userId: request.user_id,
            name: `${request.first_name} ${request.last_name}`,
            avatar: `${request.first_name.charAt(0)}${request.last_name.charAt(0)}`,
            workingIn: request.team,
            leaveType: request.leave_type,
            reason: request.reason,
            status: request.status,
            duration: request.actual_leave_days.toString(),
            statistics: {},
            startDate: request.start_date || "2023-06-01",
            endDate: request.end_date || "2023-06-05",
            updatedAt: request.updatedAt // Add this line
          };
        });
  
        setLeaveRequests(transformedData);
      } else {
        throw new Error(response.data.message?.msg || 'Failed to fetch leave requests');
      }
    } catch (error) {
      console.error('Error in fetchLeaveRequests:', error);
      setError(error.message);
      if (error.message.includes('authentication') || error.message.includes('session') ||
        error.message.includes('token') || error.message.includes('User ID')) {
        setSnackbar({
          open: true,
          message: error.message,
          severity: 'error',
          action: (
            <Button color="inherit" size="small" onClick={() => {
              window.location.href = '/login';
            }}>
              Login
            </Button>
          )
        });
      } else {
        setSnackbar({
          open: true,
          message: error.message || 'Failed to load leave requests',
          severity: 'error'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveRequests(currentPage, statusFilter);
  }, [currentPage, statusFilter, pageSize]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setCurrentPage(1);
  };

  const fetchEmployeeLeaveBalance = async (userId) => {
    setLoadingLeaveBalance(true);
    setLeaveBalanceError('');

    try {
      if (!token) {
        throw new Error('Authentication token not found. Please login again.');
      }

      const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`));
      const balanceData = response.data;

      if (balanceData.statusCode === 200 && balanceData.status === "SUCCESS" &&
        balanceData.message && Array.isArray(balanceData.message.leaveTypesWithBalance)) {


        const statistics = {};
        balanceData.message.leaveTypesWithBalance.forEach(leaveType => {
          const typeKey = leaveType.leave_type.toLowerCase().replace(' ', '_');
          statistics[typeKey] = {
            total: leaveType.allocated_days,
            used: leaveType.used_days,
            remaining: leaveType.remaining
          };
        });


        setEmployeeLeaveBalance(balanceData.message.leaveTypesWithBalance);
        setEmployeeDetailsData(prev => ({
          ...prev,
          statistics: statistics
        }));

      } else {
        throw new Error('Failed to fetch leave balance data');
      }
    } catch (error) {
      console.error('Error fetching employee leave balance:', error);
      setLeaveBalanceError('Failed to load leave balance. Please try again.');

      if (error.response && error.response.status === 403) {
        setOpenTokenExpirePopup(true);
      }
    } finally {
      setLoadingLeaveBalance(false);
    }
  };

  const handleEmployeeRowClick = (employee) => {
    setEmployeeDetailsData(employee);
    setApprovalComment('');
    setRejectionReason('');
    setActionTab(0);
    setOpenEmployeeDetails(true);
    fetchEmployeeLeaveBalance(employee.userId);
  };

  const handleLeaveApproval = async (employeeId, action, comment = '') => {
    try {
      setLoading(true);

      if (!token) {
        throw new Error('Authentication token not found. Please login again.');
      }

      const requestBody = {
        comment: action === 'approve' ? comment : rejectionReason,
        status: action === 'approve' ? "APPROVED" : "REJECTED"
      };

      const response = await axiosInstance(localAxiosPut(`/organization/approveLeave/${employeeId}`, requestBody));

      if (response.data.statusCode !== 200) {
        console.error('API Error Response:', response.data);
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }

      const data = response.data;

      if (data.statusCode === 401) {
        throw new Error('Your session has expired. Please login again.');
      }

      if (data.statusCode !== 200) {
        throw new Error(data.message || `Failed to ${action} leave request`);
      }

      setOpenEmployeeDetails(false);

      setSnackbar({
        open: true,
        message: data.message || `Leave request ${action === 'approve' ? 'approved' : 'rejected'} successfully.`,
        severity: 'success'
      });

      if (action === 'approve') {
        setApprovalComment('');
      } else {
        setRejectionReason('');
      }

      fetchLeaveRequests(currentPage, statusFilter);

    } catch (error) {
      console.error('Error in handleLeaveApproval:', error);

      if (error.message.includes('authentication') || error.message.includes('session') ||
        error.message.includes('token')) {
        setSnackbar({
          open: true,
          message: error.message,
          severity: 'error',
          action: (
            <Button color="inherit" size="small" onClick={() => {
              window.location.href = '/login';
            }}>
              Login
            </Button>
          )
        });
      } else {
        setSnackbar({
          open: true,
          message: error.message || `Failed to ${action} leave request`,
          severity: 'error'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitLeave = async () => {
    try {
      if (!leaveFormData.startDate || !leaveFormData.endDate ||
        !leaveFormData.leaveType || !leaveFormData.reason) {
        setSnackbar({
          open: true,
          message: 'Please fill all required fields',
          severity: 'error'
        });
        return;
      }

      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const userId = localStorage.getItem('userId');
      const organizationId = localStorage.getItem('organizationId');
      const reportingManagerId = localStorage.getItem('reportingmanagerId');
      const locationId = localStorage.getItem('locationId');

      if (!token || !userId || !organizationId || !reportingManagerId) {
        throw new Error('Missing required authentication information. Please login again.');
      }

      const start = new Date(leaveFormData.startDate);
      const end = new Date(leaveFormData.endDate);
      const duration = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

      const requestData = {
        user_id: parseInt(userId),
        organization_id: parseInt(organizationId),
        start_date: leaveFormData.startDate,
        end_date: leaveFormData.endDate,
        leave_type_id: parseInt(leaveFormData.leaveType),
        reason: leaveFormData.reason,
        report_manager_id: parseInt(reportingManagerId),
        leave_duration_type: "FULL_DAY",
        location_id: parseInt(locationId)
      };

      const response = await axiosInstance(localAxiosToken('/organization/createLeave', requestData));

      if (response.data.statusCode === 401) {
        throw new Error('Your session has expired. Please login again.');
      }

      if (response.data.statusCode !== 200) {
        throw new Error(response.data.message?.msg || 'Failed to submit leave request');
      }

      setOpenApplyLeave(false);
      setLeaveFormData({
        startDate: '',
        endDate: '',
        leaveType: '',
        reason: '',
        manager: '',
      });

      setSnackbar({
        open: true,
        message: 'Leave request submitted successfully',
        severity: 'success'
      });

      fetchLeaveRequests(currentPage, statusFilter);

    } catch (error) {
      console.error('Error in handleSubmitLeave:', error);

      if (error.message.includes('authentication') || error.message.includes('session') ||
        error.message.includes('token') || error.message.includes('User ID')) {
        setSnackbar({
          open: true,
          message: error.message,
          severity: 'error',
          action: (
            <Button color="inherit" size="small" onClick={() => {
              window.location.href = '/login';
            }}>
              Login
            </Button>
          )
        });
      } else {
        setSnackbar({
          open: true,
          message: error.message || 'Failed to submit leave request',
          severity: 'error'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const pendingRequestsCount = leaveRequests.filter(req => req.status === 'PENDING').length;
  const pendingPercentage = leaveRequests.length > 0
    ? (pendingRequestsCount / leaveRequests.length) * 100
    : 0;

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleMyLeavesButton = () => {
    setShowMyLeavesWindow(true)
  }

  const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
  };

  return (
    <Box sx={{ p: 3 }}>
       {showMyLeavesWindow ? (
        <>
        <Box sx={{display:'flex', justifyContent:'flex-end', mb:'-50px'}}>
          <Button 
             sx={{
              backgroundColor: '#6a1b9a',
              color: 'white',
              borderRadius: '8px',
              padding: '10px 24px',
              '&:hover': {
                backgroundColor: '#4a148c',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              },
            }}
            onClick={()=>setShowMyLeavesWindow(false)}
          >
            Leave Requests</Button>
          </Box>
        <EmployeeLeaveManagement />
        </>
      ) : (
        <>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1a1a1a', mb: 1 }}>
            Manage Leaves
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Track and manage employee leave requests
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleMyLeavesButton}
            sx={{
              backgroundColor: '#6a1b9a',
              color: 'white',
              borderRadius: '8px',
              padding: '10px 24px',
              '&:hover': {
                backgroundColor: '#4a148c',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              },
            }}
          >
            My Leaves
          </Button>

        </Box>
      </Box>
     
       
          <Grid container spacing={3} sx={{ mb: 6 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{
                height: '100%',
                backgroundColor: '#E3F2FD',
                boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                borderRadius: '16px',
              }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Badge badgeContent={pendingRequestsCount} color="error">
                      <EventNoteIcon sx={{ fontSize: 48, color: '#1565C0' }} />
                    </Badge>
                    <Box sx={{ ml: 2 }}>
                      <Typography variant="h6" sx={{ color: '#1565C0', fontWeight: 'bold' }}>
                        Employee Leave Requests
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {pendingRequestsCount} pending requests
                      </Typography>
                    </Box>
                  </Box>
                  {loading ? (
                    <LinearProgress
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: '#e3f2fd',
                      }}
                    />
                  ) : (
                    <LinearProgress
                      variant="determinate"
                      value={pendingPercentage}
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: '#e3f2fd',
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: '#1565C0',
                        }
                      }}
                    />
                  )}
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{
                height: '100%',
                backgroundColor: '#E0F2F1',
                boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                borderRadius: '16px',
              }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <DescriptionIcon sx={{ fontSize: 48, color: '#00796B' }} />
                    <Box sx={{ ml: 2 }}>
                      <Typography variant="h6" sx={{ color: '#00796B', fontWeight: 'bold' }}>
                        Leave Status Overview
                      </Typography>
                    </Box>
                  </Box>

                  {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                      <CircularProgress size={40} sx={{ color: '#00796B' }} />
                    </Box>
                  ) : leaveRequests.length === 0 ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px' }}>
                      <Typography variant="body1" color="text.secondary">
                        No leave requests to display
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="body2" sx={{ color: '#00796B', fontWeight: 'bold', mb: 2 }}>
                          Leave Status Distribution
                        </Typography>
                        <Box sx={{ mb: 1 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">Pending</Typography>
                            <Typography variant="caption" fontWeight="bold" color="#F57C00">
                              {leaveRequests.filter(req => req.status === 'PENDING').length}
                              ({((leaveRequests.filter(req => req.status === 'PENDING').length / leaveRequests.length) * 100).toFixed(1)}%)
                            </Typography>
                          </Box>
                          <LinearProgress
                            variant="determinate"
                            value={(leaveRequests.filter(req => req.status === 'PENDING').length / leaveRequests.length) * 100}
                            sx={{
                              height: 4,
                              borderRadius: 2,
                              backgroundColor: alpha('#F57C00', 0.2),
                              '& .MuiLinearProgress-bar': {
                                backgroundColor: '#F57C00',
                              }
                            }}
                          />
                        </Box>

                        <Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">Approved</Typography>
                            <Typography variant="caption" fontWeight="bold" color="#2E7D32">
                              {leaveRequests.filter(req => req.status === 'APPROVED').length}
                              ({((leaveRequests.filter(req => req.status === 'APPROVED').length / leaveRequests.length) * 100).toFixed(1)}%)
                            </Typography>
                          </Box>
                          <LinearProgress
                            variant="determinate"
                            value={(leaveRequests.filter(req => req.status === 'APPROVED').length / leaveRequests.length) * 100}
                            sx={{
                              height: 4,
                              borderRadius: 2,
                              backgroundColor: alpha('#2E7D32', 0.2),
                              '& .MuiLinearProgress-bar': {
                                backgroundColor: '#2E7D32',
                              }
                            }}
                          />
                        </Box>

                        {leaveRequests.filter(req => req.status === 'REJECTED').length > 0 && (
                          <Box sx={{ mt: 1 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="caption" color="text.secondary">Rejected</Typography>
                              <Typography variant="caption" fontWeight="bold" color="#C62828">
                                {leaveRequests.filter(req => req.status === 'REJECTED').length}
                                ({((leaveRequests.filter(req => req.status === 'REJECTED').length / leaveRequests.length) * 100).toFixed(1)}%)
                              </Typography>
                            </Box>
                            <LinearProgress
                              variant="determinate"
                              value={(leaveRequests.filter(req => req.status === 'REJECTED').length / leaveRequests.length) * 100}
                              sx={{
                                height: 4,
                                borderRadius: 2,
                                backgroundColor: alpha('#C62828', 0.2),
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: '#C62828',
                                }
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Leave Requests
            </Typography>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="status-filter-label">Status Filter</InputLabel>
              <Select
                labelId="status-filter-label"
                id="status-filter"
                value={statusFilter}
                label="Status Filter"
                onChange={handleStatusFilterChange}
              >
                <MenuItem value="ALL">All Requests</MenuItem>
                <MenuItem value="PENDING">PENDING</MenuItem>
                <MenuItem value="APPROVED">APPROVED</MenuItem>
                <MenuItem value="REJECTED">REJECTED</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <TableContainer component={Paper} sx={{ borderRadius: '12px', boxShadow: 3 }}>
            <Table>
              <TableHead sx={{
                '& .MuiTableCell-head': {
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  padding: '16px',
                },
              }}>
                <TableRow>
                  <TableCell>Employee Name</TableCell>
                  <TableCell>Team</TableCell>
                  <TableCell>Leave Type</TableCell>
                  <TableCell>Reason for Leave</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <LinearProgress sx={{ my: 2 }} />
                      <Typography variant="body2" color="text.secondary">
                        Loading leave requests...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="body2" color="error">
                        {error}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : leaveRequests.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="body2" color="text.secondary">
                        No leave requests found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  leaveRequests.map((request) => (
                    <TableRow
                      key={request.id}
                      onClick={() => handleEmployeeRowClick(request)}
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#f8f9fa',
                        },
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                          transition: 'background-color 0.2s ease',
                        },
                        cursor: 'pointer',
                      }}
                    >
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ mr: 2, bgcolor: '#1976d2' }}>{request.avatar}</Avatar>
                          <Box>
                            <Typography variant="subtitle2">{request.name}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>{request.workingIn}</TableCell>
                      <TableCell>{request.leaveType}</TableCell>
                      <TableCell>{request.reason}</TableCell>
                      <TableCell>{request.duration} day(s)</TableCell>
                      <TableCell>{formatDate(request.startDate)}</TableCell>
                      <TableCell>{formatDate(request.endDate)}</TableCell>
                      <TableCell>
                        <Chip
                          label={request.status}
                          sx={{
                            backgroundColor: request.status === 'PENDING' ? '#fff3e0' :
                              request.status === 'APPROVED' ? '#e8f5e9' : '#ffebee',
                            color: request.status === 'PENDING' ? '#f57c00' :
                              request.status === 'APPROVED' ? '#2e7d32' : '#c62828',
                            fontWeight: 'bold',
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {!loading && leaveRequests.length > 0 && (
  <Box sx={{
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderTop: '1px solid #e2e8f0',
    p: 2,
    mt: 3
  }}>
    <FormControl size="small" sx={{ minWidth: 120, mr: 2 }}>
      <InputLabel>Rows per page</InputLabel>
      <Select
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          setCurrentPage(1); // Reset to first page when changing page size
        }}
        label="Rows per page"
      >
        <MenuItem value={5}>5</MenuItem>
        <MenuItem value={10}>10</MenuItem>
        <MenuItem value={25}>25</MenuItem>
        <MenuItem value={50}>50</MenuItem>
      </Select>
    </FormControl>
    <Pagination
      count={totalPages}
      page={currentPage}
      onChange={handlePageChange}
      color="primary"
      sx={{
        '& .MuiPaginationItem-root': {
          borderRadius: '8px',
          '&.Mui-selected': {
            background: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',
            color: 'white',
            '&:hover': {
              background: 'linear-gradient(135deg, #5B5BD6 0%, #9333EA 100%)',
            }
          },
          '&:not(.Mui-selected):hover': {
            backgroundColor: 'rgba(99, 102, 241, 0.1)',
          }
        }
      }}
    />
  </Box>
)}
      
        </>
      )}

      {/* <Dialog
        open={isMyLeavesPopupOpen}
        onClose={() => setIsMyLeavesPopupOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
          },
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(90deg, #6a1b9a 0%, #8e24aa 100%)',
            p: 3,
            color: 'white',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
          }}
        >
          <Typography variant="h5" fontWeight="500">
            My Leave History
          </Typography>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl sx={{ minWidth: 120 }}>
                <InputLabel id="year-select-label">Year</InputLabel>
                <Select
                  labelId="year-select-label"
                  value={selectedYear}
                  onChange={(e) => {
                    if (e.target.name === 'year') {
                      setSelectedYear(parseInt(e.target.value));
                    }
                  }}
                  name="year"
                  sx={{ borderRadius: '8px' }}
                >
                  {[2023, 2024, 2025].filter(year => year <= new Date().getFullYear() + 1).map((year) => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 120 }}>
                <InputLabel id="month-select-label">Month</InputLabel>
                <Select
                  labelId="month-select-label"
                  value={selectedMonth}
                  onChange={(e) => {
                    if (e.target.name === 'month') {
                      setSelectedMonth(parseInt(e.target.value));
                    }
                  }}
                  name="month"
                  sx={{ borderRadius: '8px' }}
                >
                  {[
                    { value: 1, label: 'January' },
                    { value: 2, label: 'February' },
                    { value: 3, label: 'March' },
                    { value: 4, label: 'April' },
                    { value: 5, label: 'May' },
                    { value: 6, label: 'June' },
                    { value: 7, label: 'July' },
                    { value: 8, label: 'August' },
                    { value: 9, label: 'September' },
                    { value: 10, label: 'October' },
                    { value: 11, label: 'November' },
                    { value: 12, label: 'December' }
                  ]
                    .filter(month =>
                      selectedYear < new Date().getFullYear() ||
                      month.value <= new Date().getMonth() + 1
                    )
                    .map((month) => (
                      <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          {loadingMyLeaves ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
              <CircularProgress />
            </Box>
          ) : myLeavesError ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {myLeavesError}
            </Alert>
          ) : (
            <>
              {myLeaves.length > 0 ? (
                <Grid container spacing={2}>
                  {myLeaves.map((leave, index) => (
                    <Grid item xs={12} sm={6} md={4} key={leave.id || index}>
                      <Card
                        sx={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          boxShadow: 3,
                          borderRadius: 2,
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 6,
                          }
                        }}
                      >
                        <Box
                          sx={{
                            p: 2,
                            backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
                              leave.leave_type?.includes('Casual') ? '#e8f5e9' :
                                leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
                            borderBottom: '1px solid #eee'
                          }}
                        >
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Chip
                              label={leave.leave_type || "N/A"}
                              size="small"
                              sx={{
                                backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
                                  leave.leave_type?.includes('Casual') ? '#e8f5e9' :
                                    leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
                                color: leave.leave_type?.includes('Sick') ? '#c62828' :
                                  leave.leave_type?.includes('Casual') ? '#2e7d32' :
                                    leave.leave_type?.includes('Paid') ? '#1565c0' : '#6a1b9a',
                                fontWeight: 500,
                                border: '1px solid',
                                borderColor: leave.leave_type?.includes('Sick') ? '#ef9a9a' :
                                  leave.leave_type?.includes('Casual') ? '#a5d6a7' :
                                    leave.leave_type?.includes('Paid') ? '#90caf9' : '#ce93d8',
                              }}
                            />
                            <Chip
                              label={leave.status?.toUpperCase() || "N/A"}
                              size="small"
                              icon={
                                leave.status?.toLowerCase() === 'approved' ? <CheckCircleIcon /> :
                                  leave.status?.toLowerCase() === 'rejected' ? <CancelIcon /> :
                                    <PendingActions />
                              }
                              color={
                                leave.status?.toLowerCase() === 'approved' ? 'success' :
                                  leave.status?.toLowerCase() === 'rejected' ? 'error' :
                                    'warning'
                              }
                              sx={{ fontWeight: 500 }}
                            />
                          </Box>
                        </Box>
                        <CardContent sx={{ flexGrow: 1, p: 2 }}>
                          <Box sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <CalendarMonth sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                              <Typography variant="subtitle2" color="text.secondary">
                                Duration
                              </Typography>
                            </Box>
                            <Box sx={{ pl: 3.5 }}>
                              <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>From:</strong> {formatDate(leave.start_date)}
                                <Typography variant="caption" sx={{ color: 'text.secondary', ml: 1 }}>
                                  ({getDayOfWeek(leave.start_date)})
                                </Typography>
                              </Typography>
                              <Typography variant="body2">
                                <strong>To:</strong> {formatDate(leave.end_date)}
                                <Typography variant="caption" sx={{ color: 'text.secondary', ml: 1 }}>
                                  ({getDayOfWeek(leave.end_date)})
                                </Typography>
                              </Typography>
                            </Box>
                          </Box>

                          <Box sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <DescriptionIcon sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                              <Typography variant="subtitle2" color="text.secondary">
                                Reason
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                pl: 3.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical'
                              }}
                            >
                              {leave.reason || 'N/A'}
                            </Typography>
                          </Box>

                          <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Comment sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                              <Typography variant="subtitle2" color="text.secondary">
                                Comments
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                pl: 3.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical'
                              }}
                            >
                              {leave.comments || 'N/A'}
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
                  <EventNoteIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
                  <Typography variant="h6" color="text.secondary">
                    No leave records found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    You don't have any leave records for the selected period
                  </Typography>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 3,
            background: '#f8f9fa',
            borderTop: '1px solid #eee',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
          }}
        >
          <Button
            onClick={() => setIsMyLeavesPopupOpen(false)}
            variant="contained"
            sx={{
              borderRadius: 8,
              px: 3,
              py: 1,
              backgroundColor: '#6a1b9a',
              '&:hover': {
                backgroundColor: '#4a148c'
              }
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog> */}

      {/* <Dialog
        open={openApplyLeave}
        onClose={() => setOpenApplyLeave(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
          },
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
            p: 3,
            color: 'white',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
          }}
        >
          <Typography variant="h5" fontWeight="500">
            Apply for Leave
          </Typography>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <Box component="form" sx={{ mt: 2 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Start Date"
                  type="date"
                  value={leaveFormData.startDate}
                  onChange={(e) => setLeaveFormData({ ...leaveFormData, startDate: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  required
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="End Date"
                  type="date"
                  value={leaveFormData.endDate}
                  onChange={(e) => setLeaveFormData({ ...leaveFormData, endDate: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  required
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required sx={{ mb: 2 }}>
                  <InputLabel>Leave Type</InputLabel>
                  <Select
                    value={leaveFormData.leaveType}
                    onChange={(e) => setLeaveFormData({ ...leaveFormData, leaveType: e.target.value })}
                    label="Leave Type"
                  >
                    <MenuItem value="">Select a leave type</MenuItem>
                    <MenuItem value="1">Casual Leave</MenuItem>
                    <MenuItem value="2">Sick Leave</MenuItem>
                    <MenuItem value="3">Paid Leave</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Reason for Leave"
                  multiline
                  rows={4}
                  value={leaveFormData.reason}
                  onChange={(e) => setLeaveFormData({ ...leaveFormData, reason: e.target.value })}
                  required
                  sx={{ mb: 2 }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 3,
            gap: 2,
            background: '#f8f9fa',
            borderTop: '1px solid #eee',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
          }}
        >
          <Button
            onClick={() => setOpenApplyLeave(false)}
            variant="outlined"
            sx={{ borderRadius: 8, px: 3, py: 1 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitLeave}
            variant="contained"
            sx={{
              borderRadius: 8,
              px: 3,
              py: 1,
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0'
              }
            }}
          >
            Submit
          </Button>
        </Box>
      </Dialog> */}

      <Dialog
        open={openEmployeeDetails}
        onClose={() => setOpenEmployeeDetails(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
          },
        }}
      >
        {employeeDetailsData && (
          <>
            <Box
              sx={{
                background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
                p: 3,
                color: 'white',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ width: 56, height: 56, bgcolor: '#1565c0', mr: 2 }}>
                  {employeeDetailsData.avatar}
                </Avatar>
                <Box>
                  <Typography variant="h5" fontWeight="500">
                    {employeeDetailsData.name}
                  </Typography>
                  <Typography variant="subtitle1">
                    {employeeDetailsData.workingIn}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <DialogContent sx={{ p: 3 }}>
              <Grid container spacing={3}>

                <Grid item xs={12} md={6}>

                  <Card sx={{ boxShadow: 2, borderRadius: 2, height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Leave Request Details
                      </Typography>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Leave Type
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.leaveType}
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Duration
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.duration} day(s)
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Start Date
                        </Typography>
                        <Typography variant="body1">
                          {formatDate(employeeDetailsData.startDate)}
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          End Date
                        </Typography>
                        <Typography variant="body1">
                          {formatDate(employeeDetailsData.endDate)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="subtitle2" color="text.secondary">
                          Reason
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.reason}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6}>

                  <Card sx={{ boxShadow: 2, borderRadius: 2, height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Action
                      </Typography>

                      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                        <Tabs value={actionTab} onChange={(event, newValue) => setActionTab(newValue)} aria-label="action tabs">
                          <Tab
                            label="Approve"
                            sx={{
                              color: actionTab === 0 ? '#2e7d32' : 'inherit',
                              '&.Mui-selected': { color: '#2e7d32' }
                            }}
                          />
                          <Tab
                            label="Reject"
                            sx={{
                              color: actionTab === 1 ? '#c62828' : 'inherit',
                              '&.Mui-selected': { color: '#c62828' }
                            }}
                          />
                        </Tabs>
                      </Box>

                      {actionTab === 0 && (
                        <Box>
                          <TextField
                            fullWidth
                            label="Approval Comments (Optional)"
                            multiline
                            rows={4}
                            value={approvalComment}
                            onChange={(e) => setApprovalComment(e.target.value)}
                            sx={{ mb: 3 }}
                          />

                          <Button
                            fullWidth
                            variant="contained"
                            color="success"
                            onClick={() => handleLeaveApproval(employeeDetailsData.id, 'approve', approvalComment)}
                            disabled={employeeDetailsData.status !== 'PENDING'}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              fontWeight: 'bold',
                              boxShadow: 2,
                            }}
                          >
                            Approve Leave Request
                          </Button>

                          {employeeDetailsData.status !== 'PENDING' && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                              This request has already been {employeeDetailsData.status.toLowerCase()}
                            </Typography>
                          )}
                        </Box>
                      )}

                      {actionTab === 1 && (
                        <Box>
                          <TextField
                            fullWidth
                            label="Rejection Reason"
                            multiline
                            rows={4}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            required
                            error={rejectionReason.trim() === ''}
                            helperText={rejectionReason.trim() === '' ? 'Rejection reason is required' : ''}
                            sx={{ mb: 3 }}
                          />

                          <Button
                            fullWidth
                            variant="contained"
                            color="error"
                            onClick={() => handleLeaveApproval(employeeDetailsData.id, 'reject')}
                            disabled={employeeDetailsData.status !== 'PENDING' || rejectionReason.trim() === ''}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              fontWeight: 'bold',
                              boxShadow: 2,
                            }}
                          >
                            Reject Leave Request
                          </Button>

                          {employeeDetailsData.status !== 'PENDING' && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                              This request has already been {employeeDetailsData.status.toLowerCase()}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>


                <Grid item xs={12} md={6}>

                  <Card sx={{ boxShadow: 2, borderRadius: 2, height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Leave Balance
                      </Typography>

                      {loadingLeaveBalance ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                          <CircularProgress size={30} />
                        </Box>
                      ) : leaveBalanceError ? (
                        <Alert severity="error" sx={{ mb: 2 }}>
                          {leaveBalanceError}
                        </Alert>
                      ) : employeeLeaveBalance.length > 0 ? (
                        employeeLeaveBalance

                          .filter(leaveType =>
                            !leaveType.leave_type.includes("Work From Home") &&
                            !leaveType.leave_type.includes("Loss Of Pay")
                          )
                          .map(leaveType => (
                            <Box key={leaveType.leave_type_id} sx={{ mb: 2 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="subtitle2">
                                  {leaveType.leave_type}
                                </Typography>
                                <Typography variant="subtitle2">
                                  {leaveType.remaining}/{leaveType.allocated_days} days remaining
                                </Typography>
                              </Box>
                              <LinearProgress
                                variant="determinate"
                                value={(leaveType.used_days / leaveType.allocated_days) * 100}
                                sx={{
                                  height: 8,
                                  borderRadius: 4,
                                  mb: 1,
                                  backgroundColor: alpha('#1976d2', 0.2),
                                  '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2',
                                  }
                                }}
                              />
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="caption" color="text.secondary">
                                  Total: {leaveType.allocated_days} days
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  Used: {leaveType.used_days} days
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  Remaining: {leaveType.remaining} days
                                </Typography>
                              </Box>
                            </Box>
                          ))
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No leave balance information available
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6}>

                  <Card sx={{ boxShadow: 2, borderRadius: 2, height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Others
                      </Typography>

                      {loadingLeaveBalance ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                          <CircularProgress size={30} />
                        </Box>
                      ) : leaveBalanceError ? (
                        <Alert severity="error" sx={{ mb: 2 }}>
                          {leaveBalanceError}
                        </Alert>
                      ) : employeeLeaveBalance.length > 0 ? (
                        <Box>

                          {employeeLeaveBalance
                            .filter(leaveType =>
                              leaveType.leave_type.includes("Work From Home") ||
                              leaveType.leave_type.includes("Loss Of Pay")
                            )
                            .map(leaveType => (
                              <Box key={leaveType.leave_type_id} sx={{ mb: 2 }}>
                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                  {leaveType.leave_type}
                                </Typography>
                                <Box sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: '#f5f5f5',
                                  p: 1,
                                  borderRadius: 2
                                }}>
                                  <Box>
                                    <Typography variant="subtitle2" color="text.secondary">
                                      Spent
                                    </Typography>
                                    <Typography variant="h6">
                                      {leaveType.used_days} days
                                    </Typography>
                                  </Box>
                                  {leaveType.allocated_days && (
                                    <Box>
                                      <Typography variant="subtitle2" color="text.secondary">
                                        Allocated
                                      </Typography>
                                      <Typography variant="h5">
                                        {leaveType.allocated_days} days
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            ))
                          }
                        </Box>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No additional leave information available
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 3,
                background: '#f8f9fa',
                borderTop: '1px solid #eee',
                borderBottomLeftRadius: '16px',
                borderBottomRightRadius: '16px',
              }}
            >
              <Button
                onClick={() => setOpenEmployeeDetails(false)}
                variant="outlined"
                sx={{ borderRadius: 8, px: 3, py: 1 }}
              >
                Close
              </Button>
            </Box>
          </>
        )}
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%', boxShadow: 3, borderRadius: 2 }}
          action={snackbar.action}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Modal
        open={openTokenExpirePopup}
        onClose={handleCloseTokenExpirePopup}
        aria-labelledby="token-expire-modal-title"
        aria-describedby="token-expire-modal-description"
      >
        <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
      </Modal>
    </Box>
  );
};

export default EmployeeLeaves;